<template>
  <div>
    <!-- tab结束 -->
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:orgIds>
        <el-select
          multiple
          filterable
          v-model="filters.OrgIds"
          placeholder="请选择"
        >
          <el-option
            v-for="item in organizationList"
            :label="item.customName"
            :value="item.organizationId"
            :key="item.organizationId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:warehouseIDs>
        <el-select
          multiple
          filterable
          v-model="filters.WarehouseIDs"
          placeholder="请选择仓库"
        >
          <el-option
            v-for="item in warehouseList"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:status>
        <selectAllVue
          :selectOptions="statuslist"
          :mulSelecteds="filters.status"
          @update:updateMultipleSelect="(val) => (filters.status = val)"
        />
        <!-- <el-select
          multiple
          filterable
          v-model="filters.status"
          placeholder="请选择状态"
        >
          <el-option
            v-for="item in statuslist"
            :label="item.outboundText"
            :value="item.outboundId"
            :key="item.outboundId"
          ></el-option>
        </el-select> -->
      </template>
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>

      <template slot-scope="scope" slot="outboundNo">
        <hoverCopy>
          <el-link
            slot="referenceChild"
            :underline="false"
            type="primary"
            @click.native="viewloadingReviewdialog(scope.row)"
            >{{ scope.row.outboundNo }}
          </el-link>
        </hoverCopy>
      </template>
    </TwTable>

    <!-- 到仓办单 -->
    <el-dialog
      :visible.sync="addArrive"
      v-model="addArrive"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      :title="bingTitle"
      width="30%"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addRuleForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="自有单号"
              prop="orderNumber"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.orderNumber"
                :disabled="isUpdate"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="车牌号"
              prop="driverCarNumber"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.driverCarNumber"
                auto-complete="off"
                maxlength="50"
                :disabled="isUpdate"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="到仓时间"
              prop="operatingTime"
              class="labelcall"
              label-width="120px"
            >
               <el-date-picker
              v-model="addForm.operatingTime"
              type="datetime"
              placeholder="选择时间"
            >
            </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isUpdate">
          <el-col :span="24">
            <el-form-item
              label="离场时间"
              prop="leaveTime"
              class="labelcall"
              label-width="120px"
            >
               <el-date-picker
              v-model="addForm.leaveTime"
              type="datetime"
              placeholder="选择时间"
            >
            </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isUpdate">
          <el-col :span="24">
            <el-form-item
              label="实收件数"
              prop="boxCount"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.boxCount"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="addArrive = false">取消</el-button>
          <el-button
            type="primary"
            @click="onAddSubmit"
            :loading="addLoading"
            v-no-more-click
            >确定</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  getMachineReviewImages,
  getOutboundReviewImagesFileOut,
  getOutboundOrderPrint,
  outboundOrderStatusPrint,
  outboundOverPicking,
  getAreaLocation,
  JudgeOutboundInfoIsAbnormal,
  bingActualData,
  getArriveWareListAsync,
  addAppointArrive,
} from "@/api/outbound/outboundOrder.js";
import JsBarcode from "jsbarcode";
import { getReadyforTaskBasis } from "@/api/outbound/readyforTask.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
import { GetContainerTypeList } from "@/api/common/common.js";
import OutboundOrderSend from "./OutboundOrderSend.vue";
import html2canvas from "html2canvas";
import printJS from "print-js";
import OutboundOrderDetailDalog from "./OutboundOrderDetailDalog.vue";
import selectAllVue from "../../components/TwTable/selectAll.vue";
import hoverCopy from "../../components/hoverCopy.vue";

export default {
  components: {
    LogDialog,
    TwTable,
    OutboundOrderSend,
    OutboundOrderDetailDalog,
    selectAllVue,
    hoverCopy,
  },
  mixins: [TwTable_mixins],
  data() {
    return {
      isUpdate:false,
      addForm: {
        orderNumber: "",
        driverCarNumber: "",
        operatingTime:"",
        leaveTime:null,
        boxCount:0,
      },
      addFormRules: {
        orderNumber: [
          {
            required: true,
            message: "请输入自有单号",
            trigger: "blur",
          },
        ],
        driverCarNumber: [
          {
            required: true,
            message: "请输入车牌号",
            trigger: "blur",
          },
        ],
        operatingTime: [
          {
            required: true,
            message: "请输入到仓时间",
            trigger: "blur",
          },
        ],
        leaveTime: [
          {
            required: this.isUpdate?true:false,
            message: "请输入离场时间",
            trigger: "blur",
          },
        ],
        boxCount: [
          {
            required: this.isUpdate?true:false,
            message: "请输入实收件数",
            trigger: "blur",
          },
        ],
      },
      bingTitle: "",
      activeName: "0",
      outboundNoDalog: "",
      viewtypeDalog: "",
      addArrive: false,
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        column: [
          // 表格列配置
          {
            prop: "arriveWareHourseID",
            label: "到仓ID",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "orderNumber",
            label: "单号",
            align: "center",
            sortable: true,
            minWidth: "160",
          },
          {
            prop: "driverCarNumber",
            label: "车牌号",
            align: "center",
            sortable: true,
            minWidth: "160",
          },
          {
            prop: "operatingTimeText",
            label: "到仓时间",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "leaveTimeText",
            label: "离场时间",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
           {
            prop: "boxCount",
            label: "实收件数",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "operatingUser",
            label: "操作员",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
        ],
      },
      loadingReviewWinodw: "",
      loadingReviewWinodwheight: 800,
      loadingReviewdialogVisible: false,
      organizationList: [], //客户货主
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "orderNumbers",
            label: "单号",
            placeholder: "单号",
            clearable: true,
            width: 200,
          },
          {
            type: "input",
            key: "driverCarNumber",
            label: "车牌号",
            placeholder: "车牌号",
            clearable: true,
            width: 200,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "到仓时间",
            hideLabel: true,
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      buttonList: [],

      //-------------
      warehouseList: [],
      transportList: [],
      locationList: [],
      statuslist: [],
      srcList: [],
      addTaskdialogVisible: false,
      outbountPrint: {},
      boxPrint: [],
      printPickListVisible: false,
      pickingOverVisible: false,
      pickingOverForm: {},
      ContainerTypeList: [],
      completeTask: "",
      //打托
      addFormVisible: false,
      addRelotion: false,
      addLoading: false,
    };
  },

  created() {
    // 监听子组件的关闭事件
    window.addEventListener(
      "message",
      () => {
        this.closeSelf();
        this.closeReviewdialogVisible();
      },
      false
    );
  },
  methods: {
    closeSelf() {
      // 关闭当前弹框
      this.addTaskdialogVisible = false;
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    resetBtn() {},

    //查询列表
    initTable() {
      const { orderNumbers, tdate, driverCarNumber } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        orderNumbers,
        driverCarNumber,
      };
      console.info(para);
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getArriveWareListAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    //预览图片
    getReadyImages(id) {
      const data = {
        actualEntryDataId: id,
      };
      //this.showPreviewImg = false;
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getMachineReviewImages(data).then((res) => {
        loading.close();
        if (res.data.status === 200 && res.data.success) {
          const { response } = res.data;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });
          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
    //下载照片
    handleImages(id) {
      const data = {
        outboundID: id,
      };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(getOutboundReviewImagesFileOut, {
          params: data,
        })
        .then((res) => {
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //打印装车单查询
    printPickList() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      getOutboundOrderPrint({ outboundID: row[0].tfOutboundID }).then((res) => {
        if (res.data.success) {
          this.printPickListVisible = true;
          this.boxPrint = res.data.response.outbountDetailList;
          this.outbountPrint = res.data.response;
          this.$nextTick(() => {
            JsBarcode("#barcode1", this.outbountPrint.outboundNo, {
              format: "CODE128", //条形码的格式
              font: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif",
              displayValue: true,
              width: 2, //线宽
              height: 90, //条码高度
              lineColor: "#000", //线条颜色
              displayValue: true, //是否显示文字
              margin: 2, //设置条形码周围的空白区域
            });
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //打印装车单
    printLoadCar() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      var that = this;
      outboundOrderStatusPrint({ outboundID: row[0].tfOutboundID }).then(
        (res) => {
          if (res.data.success) {
            that.toImg();
            this.initTable();
            this.printPickListVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    },
    //加载基础资料
    getBasicdatalist() {
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = user.warehouseList;
      getReadyforTaskBasis("").then((res) => {
        this.transportList = res.data.response.transportdata;
        this.statuslist = this.formatterOption(
          res.data.response.outboundStatusdata,
          "outboundText",
          "outboundId"
        );
      });
    },
    formatterOption(option, labelKey, valueKey) {
      return (
        option &&
        option.map((item) => {
          item.label = item[labelKey];
          item.value = item[valueKey];
          return item;
        })
      );
    },

    pickingOverSubmit() {
      const that = this;
      console.info(that.pickingOverForm);
      if (
        that.pickingOverForm.Storages == null ||
        that.pickingOverForm.Storages == ""
      ) {
        this.$message({
          message: "请输入库位",
          type: "error",
        });
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      const data = {
        TFOutboundID: that.pickingOverForm.TFOutboundID,
        OutboundNo: that.pickingOverForm.OutboundNo,
        Storages: that.pickingOverForm.Storages.join(","),
      };

      outboundOverPicking(data).then((res) => {
        loading.close();
        if (res.status === 200 && res.success) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.pickingOverVisible = false;
          this.initTable();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    pickingOver() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }

      if (this.selectRows.rows[0].outboundStatus != 20) {
        this.$message({
          message: "只有[拣货中]才允许操作,请确认！",
          type: "error",
        });
        return;
      }

      this.pickingOverForm = {
        TFOutboundID: row[0].tfOutboundID,
        OutboundNo: row[0].outboundNo,
        Storages: [],
      };
      this.pickingOverVisible = true;

      const para = {
        warehouseId: row[0].warehouseId,
        area: "",
      };
      getAreaLocation(para).then((res) => {
        if (res.data.success == true) {
          this.locationList = res.data.response;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          return;
        }
      });
    },

    addArrvieAsy() {

      this.addArrive = true;
      this.isUpdate=false;
      this.addForm.arriveWareHourseID=0;
      this.addForm.orderNumber="";
      this.addForm.driverCarNumber="";
      this.addForm.operatingTime=new Date();
    },
    updateArrvieAsy() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if (row != null && row.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });
        return;
      }
      if(row[0].boxCount>0)
      {
        this.$message({
          message: "此票已离场,请重新选择",
          type: "error",
        });
        return;
      }
      this.addArrive = true;
      this.isUpdate=true;
      this.addForm.arriveWareHourseID=row[0].arriveWareHourseID;
      this.addForm.orderNumber=row[0].orderNumber;
      this.addForm.driverCarNumber=row[0].driverCarNumber;
      this.addForm.operatingTime=row[0].operatingTime;
      this.addForm.leaveTime=new Date();
    },
    //绑定
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);
      let _this = this;
      console.log(para);
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          addAppointArrive(para).then((res) => {
            this.addLoading = false;
            console.log(res);
            if (res.data.success) {
              this.addFormVisible = false;
              this.$refs["addRuleForm"].resetFields();
              this.initTable();
              this.addArrive=false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    let user = JSON.parse(window.localStorage.user);
    this.organizationList = user.organizationList;
    this.getBasicdatalist();
  },
};
</script>

<style lang="less">
.content-az {
  overflow-x: hidden;
}
.printDalog {
  .el-dialog__body {
    padding-top: 0;
  }
}
.printRow {
  position: absolute;
  right: 20px;
}
.dialogClass {
  .el-dialog {
    .el-dialog__body {
      //border-top: 1px solid #dcdfe6;
      //border-bottom: 1px solid #dcdfe6;
      max-height: 2000px !important;
      min-height: 500px;
      overflow-y: hidden;
    }
  }
  .el-dialog.is-fullscreen {
    max-height: 2000px !important;
    min-height: 500px;
  }
}
.printList {
  font-size: 16px;
  margin-bottom: 14px;
}
#completeDivd {
  font-size: 16px;
  width: 80%;
  margin: 0 auto;
}
</style>

<style type="text/css" media="print">
@page {
  size: landscape;
}
</style>

<style>
figure {
  page-break-inside: avoid;
}
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
</style>